import { axiosInstanceV2 } from "./AxiosInstance"

const API_URL = "/operations"

export const getOperations = async (limit = 10, page = 1, search = "", searchField = "") => {
  try {
    let queryParams = `?limit=${limit}&page=${page}`
    if (search) {
      queryParams += `&search=${encodeURIComponent(search)}`
    }
    if (searchField) {
      queryParams += `&searchField=${searchField}`
    }
    const response = await axiosInstanceV2.get(`${API_URL}${queryParams}`)
    return {
      data: response.data.data,
      pagination: response.data.pagination,
    }
  } catch (error) {
    console.error("Error fetching operations", error)
    throw error
  }
}

export const createOperation = async (operationData) => {
  try {
    const response = await axiosInstanceV2.post(API_URL, operationData)
    return response.data
  } catch (error) {
    console.error("Error creating operation", {
      error: error.response?.data,
      requestData: operationData,
    })
    throw error
  }
}

export const updateOperation = async (operationId, operationData) => {
  try {
    const response = await axiosInstanceV2.put(`${API_URL}/${operationId}`, operationData)
    return response.data
  } catch (error) {
    console.error("Error updating operation", error)
    throw error
  }
}

export const deleteOperation = async (operationId) => {
  try {
    const response = await axiosInstanceV2.delete(`${API_URL}/${operationId}`)
    return response.data
  } catch (error) {
    console.error("Error deleting operation", error)
    throw error
  }
}

export const getOperationById = async (operationId) => {
  try {
    const response = await axiosInstanceV2.get(`${API_URL}/${operationId}`)
    return {
      data: response.data.data,
      status: response.status,
      message: response.data.message,
    }
  } catch (error) {
    console.error("Error fetching operation details", error)
    throw error
  }
}
